import { createResponse } from '../response'

const normalizeCreditcardsResponse = (data) => {
  let ours = []
  data.savedCreditCards.forEach(function (item) {
    let normalized = theirCreditcardToOurCreditcard(item)
    if (item.expirationDate) {
      normalized.isPaypal = false
    } else normalized.isPaypal = true
    normalized.isPrimary = data.preferredPaymentInfoId === normalized.id
    ours.push(normalized)
  })
  return createResponse(ours)
}

const iter = (o, val) => {
  let methodArr = Object.keys(o)
  for (var i in methodArr) {
    if (o[i].method.id === val) { return { providerId: o[i].provider.id, name: o[i].provider.name } }
  } return 'couldnt match method id to provider'
}

const findPaymentMethodById = (data) => {
  return iter(data.paymentMethods, '1001')
}

const theirCreditcardToOurCreditcard = (data) => {
  let normalized = {
    'id': data.paymentInfoId,
    'autoTopUpAmount': data.autoTopUpAmount,
    'autoTopUpEnabled': data.autoTopUpEnabled,
    'description': data.description,
    'expirationDate': data.expirationDate,
    'paymentAddress': data.paymentAddress,
    'subscriptionConnected': data.subscriptionConnected,
    'supportRecurring': data.supportRecurring,
    'provider': { id: data.providerId },
    'method': { id: data.method }
  }
  return normalized
}

export {
  normalizeCreditcardsResponse,
  theirCreditcardToOurCreditcard,
  findPaymentMethodById
}



// WEBPACK FOOTER //
// ./src/api/order/normalize.js